/**
 * Standard error categories for OCR SDK operations
 */ var ErrorCategory;
(function(ErrorCategory) {
    ErrorCategory["AUTHENTICATION"] = "AUTHENTICATION";
    ErrorCategory["VALIDATION"] = "VALIDATION";
    ErrorCategory["NETWORK"] = "NETWORK";
    ErrorCategory["PROCESSING"] = "PROCESSING";
    ErrorCategory["SERVER"] = "SERVER";
    ErrorCategory["UNKNOWN"] = "UNKNOWN";
})(ErrorCategory || (ErrorCategory = {}));
/**
 * Standardized OCR SDK error
 */ class OcrError extends Error {
    /**
   * Creates a JSON representation of the error
   */ toJSON() {
        return {
            name: this.name,
            message: this.message,
            code: this.code,
            statusCode: this.statusCode,
            category: this.category,
            details: this.details,
            stack: this.stack
        };
    }
    constructor({ message, code, statusCode, category = "UNKNOWN", details, cause }){
        super(message);
        this.name = 'OcrError';
        this.code = code;
        this.statusCode = statusCode;
        this.category = category;
        this.details = details;
        this.cause = cause;
        // Maintains proper stack trace for where our error was thrown (only V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, OcrError);
        }
    }
}

export { ErrorCategory, OcrError };
